/*
 * Copyright (c) 2024, King Living
 * Slug extraction for Dynamic Page Routing (TSD Contentful).
 */

import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config';
import {removeLocaleFromPath, removeSiteLocaleFromPath} from '@amblique/king-living/app/utils/url';

/**
 * Get Contentful slug from current pathname (strip site/locale prefix).
 * When app.url.site is "none", site is implied by host — keep site segments in the
 * path so /kl-au does not collapse to home (KINDW-1680).
 *
 * @param {string} pathname - location.pathname
 * @returns {string} Slug for Contentful (e.g. 'sofa/jasper', '' for home)
 */
export function getSlugFromPathname(pathname) {
  if (typeof pathname !== 'string' || pathname === '/') return '';

  const urlSiteMode = getConfig()?.app?.url?.site;
  const pathWithoutSiteLocale =
    urlSiteMode === 'none' ?
      removeLocaleFromPath(pathname) :
      removeSiteLocaleFromPath(pathname);

  return pathWithoutSiteLocale.replace(/^\//, '').trim().replace(/\/+$/, '');
}
